import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { site } from "@/config/site";
import { Seo } from "@/components/Seo";
import { LocalBusinessJsonLd } from "@/components/LocalBusinessJsonLd";
import { PageHero } from "@/components/PageHero";
import { SectionHeading } from "@/components/SectionHeading";
import { WhatsAppButton } from "@/components/CtaButtons";
import { CtaBlock } from "@/components/CtaBlock";

export default function Services() {
  return (
    <>
      <Seo
        title="Masaj Hizmetleri | Klasik, Medikal, Soft, Kese & Köpük | Lavenza Bursa"
        description="Lavenza Masaj Salonu Bursa Nilüfer'de klasik masaj, medikal masaj, soft masaj ve kese köpük hizmetleri. Fiyat ve süre bilgisi için WhatsApp'tan yazın."
        path="/masaj-hizmetleri"
      />
      <LocalBusinessJsonLd />
      <PageHero
        eyebrow="Hizmetlerimiz"
        accent="Masaj"
        title="Hizmetleri"
        text={`Bursa Nilüfer'de klasik, medikal, soft masaj ve kese & köpük. ${site.priceNote}`}
        crumbs={[{ label: "Ana Sayfa", path: "/" }, { label: "Hizmetler", path: "/masaj-hizmetleri" }]}
        testId="services-hero"
      />
      <section className="section bg-white" data-testid="services-list">
        <div className="container-wide">
          <SectionHeading eyebrow="Detaylar" accent="Size Uygun" title="Uygulamayı Seçin" lead="Hangi uygulamanın size uygun olduğundan emin değilseniz WhatsApp'tan kısaca durumunuzu anlatın; yönlendirelim." />
          <div className="space-y-8">
            {site.services.map((s, i) => (
              <article id={s.slug} key={s.slug} className={`card overflow-hidden grid lg:grid-cols-2 hover-lift ${i % 2 ? "lg:[&>img]:order-2" : ""}`} data-testid={`service-detail-${s.slug}`}>
                <img src={s.image} alt={s.alt} width="1200" height="800" loading="lazy" className="h-64 lg:h-full w-full object-cover" />
                <div className="p-7 md:p-10 flex flex-col justify-center">
                  <span className="eyebrow mb-2">{s.subtitle}</span>
                  <h2 className="text-2xl md:text-3xl font-bold text-emerald">{s.name}</h2>
                  <p className="mt-4 text-muted leading-relaxed">{s.detail}</p>
                  <p className="mt-3 text-sm font-semibold text-gold-dark">{site.priceNote}</p>
                  <div className="mt-6 flex flex-wrap gap-3">
                    <WhatsAppButton label="WhatsApp'tan Sor" testId={`service-whatsapp-${s.slug}`} />
                    {s.slug !== "kese-kopuk" && (
                      <Link to={s.path} className="btn btn-outline" data-testid={`service-link-${s.slug}`}>
                        Detay Sayfası <ArrowRight size={16} aria-hidden="true" />
                      </Link>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
      <CtaBlock />
    </>
  );
}
